import { render } from "./UserInfo.vue?vue&type=template&id=3474f7c4&scoped=true&ts=true"
import script from "./UserInfo.vue?vue&type=script&lang=ts"
export * from "./UserInfo.vue?vue&type=script&lang=ts"

import "./UserInfo.vue?vue&type=style&index=0&id=3474f7c4&lang=css"
import "./UserInfo.vue?vue&type=style&index=1&id=3474f7c4&scoped=true&lang=scss"

import exportComponent from "D:\\Project\\wallet\\wallet-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3474f7c4"]])

export default __exports__